import Vue from "vue";
import Router from "vue-router";
import axios from "axios";
import i18n from "@/lang/index.js";
import {
  LANG_PATTERN,
  DEFAULT_LOCALE,
  localeInfo,
  localeFromSegment,
  segmentFromLocale,
  stripLangPrefix,
  withLangPrefix,
} from "@/plugins/i18n-routing";
const Register = () => import("@/views/register.vue");
const Home = () => import("@/views/home.vue");
const Login = () => import("@/views/login.vue");
const Cabinet = () => import("@/views/cabinet/index.vue");
const MyInfo1 = () => import("@/views/cabinet/myinfo1.vue");
const MyObligations = () => import("@/views/obligations/index.vue");
const Oferta = () => import("@/views/oferta.vue");
const Privacy = () => import("@/views/privacy_policy.vue");
const News = () => import("@/views/news/index.vue");
const Inspector = () => import("@/views/inspector/index.vue");
const MaxsusGuvohnoma = () => import("@/views/maxsusguvohnoma/index.vue");
const ControlFunction = () => import("@/views/controlfunction/index.vue");
const Complaint = () => import("@/views/complaint/index.vue");
const ComplaintView = () => import("@/views/complaint/view.vue");
const EditComplaint = () => import("@/views/complaint/edit.vue");
const MandatoryRequirement = () =>
  import("@/views/mandatoryrequirement/index.vue");
const Request = () => import("@/views/cabinet/request/index.vue");
const RequestView = () => import("@/views/cabinet/request/view.vue");
const InspectionBookOfContractor = () =>
  import("@/views/inspectionbookofcontractor/index.vue");
const InspectionBookOfContractorEdit = () =>
  import("@/views/inspectionbookofcontractor/edit.vue");
const InspectionBookOfContractorView = () =>
  import("@/views/inspectionbookofcontractor/view.vue");
const InspectionBook = () => import("@/views/inspectionbook/index.vue");
const InspectionBookEdit = () => import("@/views/inspectionbook/edit.vue");
const InspectionBookCombined = () =>
  import("@/views/inspectionbookcombined/index.vue");
const InspectionBookCombinedView = () =>
  import("@/views/inspectionbookcombined/view.vue");
const InspectionBookCombinedEdit = () =>
  import("@/views/inspectionbookcombined/edit.vue");
const InspectionBookNew = () => import("@/views/inspectionbooknew/index.vue");
const InspectionBookNewEdit = () => import("@/views/inspectionbooknew/edit.vue");
const Oked = () => import("@/views/oked/index.vue");
const VideoLesson = () => import("@/views/videolesson/index.vue");
const DishonestRequest = () => import("@/views/dishonestrequest/index.vue");
const PublicReception = () => import("@/views/publicreception/index.vue");
const PublicReceptionView = () => import("@/views/publicreception/view.vue");
const Support = () => import("@/views/support.vue");
const BiznesHimoya = () => import("@/views/biznes-himoya/index.vue");
const QrInspectionEdit = () => import("@/views/qr-inspection/edit.vue");
const OneIdCallback = () => import("@/views/oneid-callback.vue");
const CorruptionReport = () => import("@/views/corruptionreport/index.vue");
const MahallaPortal = () => import("@/views/mahallaportal/index.vue");
const Rating = () => import("@/views/rating/index.vue");
const RatingEdit = () => import("@/views/rating/edit.vue");
const MuloqotList = () => import("@/views/muloqotlist/index.vue");
const MuloqotListView = () => import("@/views/muloqotlist/view.vue");
const Xabarnoma = () => import("@/views/xabarnoma/index.vue");
const XabarnomaView = () => import("@/views/xabarnoma/view.vue");
const XabarnomaReply = () => import("@/views/xabarnoma/reply.vue");
Vue.use(Router);

// Har bir route yo'liga ixtiyoriy til prefiksini qo'shamiz. Route `name`'lari
// tegilmaydi — shu sababli kod bazasidagi 55 ta `push({ name: ... })`
// chaqiruvi o'zgarishsiz ishlaydi.
function withLangRoutes(list) {
  list.forEach((route) => {
    route.path = LANG_PATTERN + (route.path === "/" ? "" : route.path);
  });
  return list;
}

const router = new Router({
  mode: "history", // https://router.vuejs.org/api/#mode
  linkActiveClass: "active",
  base: process.env.BASE_URL,
  scrollBehavior: () => ({
    y: 0,
    x: 0,
  }),
  routes: withLangRoutes([
    {
      path: "/",
      name: "Home",
      component: Home,
      meta: {
        isAuth: false,
      },
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
      meta: {
        isAuth: false,
      },
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        isAuth: false,
      },
    },
    {
      path: "/cabinet",
      name: "Cabinet",
      component: Cabinet,
      meta: {
        isAuth: true,
      },
    },
    {
      path: "/oferta",
      name: "Oferta",
      component: Oferta,
      meta: {
        isAuth: false,
      },
    },
    {
      path: "/privacy_policy",
      name: "Privacy",
      component: Privacy,
      meta: {
        isAuth: false,
      },
    },

    {
      path: "/myinfo",
      name: "info",
      component: MyInfo1,
      meta: {
        isAuth: true,
        title: "myinfo",
      },
    },
    {
      path: "/obligations",
      name: "obligations",
      component: MyObligations,
      meta: {
        isAuth: true,
        title: "obligations",
      },
    },
    {
      path: "/inspector",
      name: "inspector",
      component: Inspector,
      meta: {
        isAuth: true,
        title: "Inspector",
      },
    },
    {
      path: "/maxsusguvohnoma",
      name: "maxsusguvohnoma",
      component: MaxsusGuvohnoma,
      meta: {
        isAuth: true,
        title: "MaxsusGuvohnoma",
      },
    },
    {
      path: "/controlfunction",
      name: "controlfunction",
      component: ControlFunction,
      meta: {
        isAuth: false,
        title: "ControlFunction",
      },
    },
    {
      path: "/complaint",
      name: "complaint",
      component: Complaint,
      meta: {
        isAuth: true,
        title: "Complaint",
      },
    },
    {
      path: "/complaint/edit/id=:id",
      name: "EditComplaint",
      component: EditComplaint,
      meta: {
        isAuth: true,
        title: "Complaint",
      },
    },
    {
      path: "/complaint/view/id=:id",
      name: "ComplaintView",
      component: ComplaintView,
      meta: {
        isAuth: true,
        title: "Complaint",
      },
    },
    {
      path: "/mandatoryrequirement",
      name: "mandatoryrequirement",
      component: MandatoryRequirement,
      meta: {
        isAuth: false,
        title: "MandRequirement",
      },
    },
    {
      path: "/inspectionbookofcontractor",
      name: "inspectionbookofcontractor",
      component: InspectionBookOfContractor,
      meta: {
        isAuth: true,
        title: "inspectionbookAll",
      },
    },
    {
      path: "/inspectionbookofcontractor/edit/id=:id",
      name: "InspectionBookOfContractorEdit",
      component: InspectionBookOfContractorEdit,
      meta: {
        isAuth: true,
        title: "inspectionbookAll",
      },
    },
    {
      path: "/inspectionbookofcontractor/view/id=:id",
      name: "InspectionBookOfContractorView",
      component: InspectionBookOfContractorView,
      meta: {
        isAuth: true,
        title: "inspectionbookAll",
      },
    },
    {
      path: "/inspectionbook",
      name: "inspectionbook",
      component: InspectionBook,
      meta: {
        isAuth: true,
        title: "inspectionbookAll",
      },
    },
    {
      path: "/inspectionbook/edit/id=:id",
      name: "InspectionBookEdit",
      component: InspectionBookEdit,
      meta: {
        isAuth: true,
        title: "inspectionbookAll",
      },
    },
    {
      path: "/inspectionbookcombined",
      name: "inspectionbookcombined",
      component: InspectionBookCombined,
      meta: {
        isAuth: true,
        title: "inspectionbookAll",
      },
    },
    {
      path: "/inspectionbookcombined/view/id=:id",
      name: "InspectionBookCombinedView",
      component: InspectionBookCombinedView,
      meta: {
        isAuth: true,
        title: "inspectionbookAll",
      },
    },
    {
      path: "/inspectionbookcombined/edit/id=:id",
      name: "InspectionBookCombinedEdit",
      component: InspectionBookCombinedEdit,
      meta: {
        isAuth: true,
        title: "inspectionbookAll",
      },
    },
    {
      path: "/inspectionbooknew",
      name: "inspectionbooknew",
      component: InspectionBookNew,
      meta: {
        isAuth: false,
        title: "inspectionbookAll",
      },
    },
    {
      path: "/inspectionbooknew/edit/id=:id",
      name: "InspectionBookNewEdit",
      component: InspectionBookNewEdit,
      meta: {
        isAuth: false,
        title: "inspectionbookAll",
      },
    },
    {
      path: "/request",
      name: "Request",
      component: Request,
      meta: {
        isAuth: true,
        title: "RequestInfo",
      },
    },
    {
      path: "/request/view/id=:id",
      name: "RequestView",
      component: RequestView,
      meta: {
        isAuth: true,
        title: "RequestInfo",
      },
    },
    {
      path: "/oked",
      name: "oked",
      component: Oked,
      meta: {
        isAuth: true,
        title: "Oked",
      },
    },
    {
      path: "/videolesson",
      name: "videolesson",
      component: VideoLesson,
      meta: {
        isAuth: true,
        title: "videolesson",
      },
    },
    {
      path: "/dishonestrequest",
      name: "dishonestrequest",
      component: DishonestRequest,
      meta: {
        isAuth: true,
        title: "DishonestRequest",
      },
    },
    {
      path: "/publicreception",
      name: "publicreception",
      component: PublicReception,
      meta: {
        isAuth: true,
        title: "PublicReception",
      },
    },
    {
      path: "/publicreception/view/id=:id",
      name: "PublicReceptionView",
      component: PublicReceptionView,
      meta: {
        isAuth: true,
        title: "PublicReception",
      },
    },
    {
      path: "/news",
      name: "News",
      component: News,
      meta: {
        isAuth: false,
        title: "News",
      },
    },
    {
      path: "/support",
      name: "Support",
      component: Support,
      meta: {
        isAuth: false,
        title: "Support",
      },
    },
    {
      path: "/qr",
      name: "BiznesHimoya",
      component: BiznesHimoya,
      meta: {
        isAuth: false,
      },
    },
    {
      path: "/qr/profilaktika",
      name: "QrProfilaktika",
      component: QrInspectionEdit,
      meta: {
        isAuth: false,
        kind: "profilaktika",
        title: "inspectionbookAll",
      },
    },
    {
      path: "/qr/muloqot",
      name: "QrMuloqot",
      component: QrInspectionEdit,
      meta: {
        isAuth: false,
        kind: "muloqot",
        title: "inspectionbookAll",
      },
    },
    {
      path: "/corruptionreport",
      name: "corruptionreport",
      component: CorruptionReport,
      meta: {
        isAuth: true,
        title: "CorruptionReport",
      },
    },
    {
      path: "/mahallaportal",
      name: "mahallaportal",
      component: MahallaPortal,
      meta: {
        isAuth: true,
        title: "MahallaPortal",
      },
    },
    {
      path: "/rating",
      name: "rating",
      component: Rating,
      meta: {
        isAuth: true,
        title: "Rating",
      },
    },
    {
      path: "/rating/edit/id=:id",
      name: "RatingEdit",
      component: RatingEdit,
      meta: {
        isAuth: true,
        title: "Rating",
      },
    },
    {
      path: "/muloqotlist",
      name: "muloqotlist",
      component: MuloqotList,
      meta: {
        isAuth: true,
        title: "MuloqotList",
      },
    },
    {
      path: "/muloqotlist/view/id=:id",
      name: "MuloqotListView",
      component: MuloqotListView,
      meta: {
        isAuth: true,
        title: "MuloqotList",
      },
    },
    {
      path: "/xabarnoma",
      name: "xabarnoma",
      component: Xabarnoma,
      meta: {
        isAuth: true,
        title: "Xabarnoma",
      },
    },
    {
      path: "/xabarnoma/view/id=:id",
      name: "XabarnomaView",
      component: XabarnomaView,
      meta: {
        isAuth: true,
        title: "Xabarnoma",
      },
    },
    {
      path: "/xabarnoma/reply/id=:id",
      name: "XabarnomaReply",
      component: XabarnomaReply,
      meta: {
        isAuth: true,
        title: "Xabarnoma",
      },
    },
    {
      path: "/oneid/callback",
      name: "OneIdCallback",
      component: OneIdCallback,
      meta: {
        isAuth: false,
      },
    },
  ]),
});

// Joriy faol til. push/replace chaqiruvlariga prefiksni avtomatik qo'shish
// uchun kerak; beforeEach har navigatsiyada yangilab boradi.
let activeLocale = i18n.locale;

// Til bilan bog'liq global holatni bitta joyda sinxronlaymiz. Kod bazasidagi
// ~10 ta komponent hamon localStorage'dan o'qiydi — shuning uchun uni ham
// yozib qo'yamiz va o'sha komponentlarga tegmaymiz.
function syncLocale(locale) {
  activeLocale = locale;
  i18n.locale = locale;
  localStorage.setItem("locale", locale);
  axios.defaults.params = Object.assign({}, axios.defaults.params, {
    __lang: localeInfo(locale).apiLang,
  });
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("lang", localeInfo(locale).htmlLang);
  }
}

// push('/cabinet') yoki push({ name }) — ikkalasiga ham joriy til prefiksini
// qo'shamiz, aks holda til almashgach navigatsiya standart tilga tushib qolardi.
function withActiveLang(location) {
  const segment = segmentFromLocale(activeLocale);
  if (!segment) return location;

  if (typeof location === "string") {
    if (location.charAt(0) !== "/") return location;
    return withLangPrefix(location, activeLocale);
  }
  if (location && typeof location === "object") {
    if (location.name) {
      return Object.assign({}, location, {
        params: Object.assign({ lang: segment }, location.params),
      });
    }
    if (typeof location.path === "string" && location.path.charAt(0) === "/") {
      return Object.assign({}, location, {
        path: withLangPrefix(location.path, activeLocale),
      });
    }
  }
  return location;
}

// Vue Router 3 bir xil manzilga o'tishda "NavigationDuplicated" rejection
// beradi. Prefiks avtomatik qo'shilgani uchun bu holat ko'payadi — yutamiz.
function isHarmlessFailure(err) {
  return (
    err &&
    (err.name === "NavigationDuplicated" ||
      /redirected|aborted|cancelled|duplicated/i.test(err.message || ""))
  );
}

["push", "replace"].forEach((method) => {
  const original = Router.prototype[method];
  Router.prototype[method] = function (location, onComplete, onAbort) {
    const target = withActiveLang(location);
    if (onComplete || onAbort) {
      return original.call(this, target, onComplete, onAbort);
    }
    return original.call(this, target).catch((err) => {
      if (!isHarmlessFailure(err)) throw err;
    });
  };
});

router.beforeEach((to, from, next) => {
  const urlLocale = localeFromSegment(to.params.lang);
  const storedLocale = localStorage.getItem("locale");

  // URL'da prefiks yo'q, lekin foydalanuvchi ilgari boshqa tilni tanlagan —
  // URL har doim ko'rinayotgan tilni aks ettirishi uchun prefiksli manzilga
  // o'tkazamiz. Crawler'da localStorage yo'q, shuning uchun ular hech qachon
  // bu shoxga tushmaydi va standart til URL'ini indekslayveradi.
  if (!to.params.lang && storedLocale && storedLocale !== DEFAULT_LOCALE) {
    const segment = segmentFromLocale(storedLocale);
    if (segment) {
      syncLocale(storedLocale);
      next({
        path: "/" + segment + (to.path === "/" ? "" : to.path),
        query: to.query,
        hash: to.hash,
        replace: true,
      });
      return;
    }
  }

  syncLocale(urlLocale);

  if (stripLangPrefix(to.path) === "/cabinet" && to.query && to.query.code) {
    next({
      name: "OneIdCallback",
      params: { lang: to.params.lang },
      query: to.query,
    });
    return;
  }
  var auth = localStorage.getItem("user_info");
  if (to.meta.isAuth === true) {
    if (!!auth) {
      next();
    } else {
      next({ name: "Home", params: { lang: to.params.lang } });
    }
  } else {
    next();
  }
});
export default router;
